import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { GasTemplateModule } from '../../utils/gas-template/gas-template.module';
import { GasIconsModule } from '../../utils/gas-icons/gas-icons.module';
import { GasCheckboxModule } from '../../forms/gas-checkbox/gas-checkbox.module';
import { GasButtonModule } from '../../forms/gas-button/gas-button.module';
import { GasEmptyMessageModule } from '../gas-empty-message/gas-empty-message.module';

// todo: объединить в один модуль
import { GasTableHeaderModule } from '../gas-table-header/gas-table-header.module';
import { GasFiltersModule } from '../gas-filters/gas-filters.module';

import { GasTableComponent } from './gas-table/gas-table.component';
import { GasTableRadioComponent } from './gas-table-radio/gas-table-radio.component';
import { GasTableCheckboxComponent } from './gas-table-checkbox/gas-table-checkbox.component';
import { GasTableHeaderCheckboxComponent } from './gas-table-header-checkbox/gas-table-header-checkbox.component';
import { GasSelectableTableRowComponent } from './gas-selectable-table-row/gas-selectable-table-row.component';
import { GasSelectableTableHeadRowComponent } from './gas-selectable-table-head-row/gas-selectable-table-head-row.component';
import { GasPaginatorModule } from '../gas-paginator/gas-paginator.module';
import { GasSelectModule } from '../../forms/gas-select/gas-select.module';
import { GasPaginator } from '../gas-paginator/gas-paginator.namespace';
import {
  DEFAULT_PAGINATOR_DATA,
  DEFAULT_QUERY_PARAMS,
  DEFAULT_REPOSITORY_PARAMS_TOKEN,
  DEFAULT_TABLE_DATA_PIPE,
  GasArgumentStream,
  GasUrlQueryParams,
} from './gas-default-table.repository';
import { GasSpinnerModule } from '../gas-spinner/gas-spinner.module';
import { GasTableSortingComponent } from './gas-table-sorting/gas-table-sorting.component';
import { GasSortingtableHeadRowDirective } from './gas-table-sorting/gas-sorting-table-head-row.directive';
import { GasScrollModule } from '../../utils/gas-scroll/gas-scroll.module';
import { GasTableAutoColumnsDirective } from './gas-table-auto-columns.directive';
import { GasCustomTableFilterDirective } from './gas-custom-table-filter/gas-custom-table-filter.directive';
import { GasSimpleTableComponent } from './gas-simple-table/gas-simple-table.component';
import { GasPopupModule } from '../gas-popup/gas-popup.module';
import { GasTagsModule } from '../gas-tags/gas-tags.module';
import { GasTableColumnSettingsComponent } from './gas-table-column-settings/gas-table-column-settings.component';

const COMPONENTS = [
  GasTableComponent,
  GasTableRadioComponent,
  GasTableCheckboxComponent,
  GasTableHeaderCheckboxComponent,
  GasSelectableTableRowComponent,
  GasSelectableTableHeadRowComponent,
  GasTableSortingComponent,
  GasSimpleTableComponent,
  GasTableColumnSettingsComponent,
];

const DIRECTIVES = [
  GasSortingtableHeadRowDirective,
  GasTableAutoColumnsDirective,
  GasCustomTableFilterDirective,
];

@NgModule({
  declarations: [
    COMPONENTS,
    DIRECTIVES,
  ],
  exports: [
    COMPONENTS,
    DIRECTIVES,
  ],
  entryComponents: [
    GasTableSortingComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GasTableHeaderModule,
    GasFiltersModule,
    GasIconsModule,
    GasCheckboxModule,
    GasTemplateModule,
    GasButtonModule,
    GasEmptyMessageModule,
    GasPaginatorModule,
    GasSelectModule,
    GasSpinnerModule,
    GasPopupModule,
    GasScrollModule,
    GasTagsModule,
  ],
  providers: [
    {
      provide: DEFAULT_REPOSITORY_PARAMS_TOKEN,
      useValue: {
        queryUrl: '',
        queryParamNames: DEFAULT_QUERY_PARAMS,
        defaultPaginatorData: DEFAULT_PAGINATOR_DATA,
        dataPipe: DEFAULT_TABLE_DATA_PIPE,
      },
    },
    DatePipe,
  ],
})
export class GasTableModule {
  /** @description - метод принимает настройки репозитория таблицы,
   * полученные данные предоставляет как стандартные для репозитория таблицы*/
  public static forRoot(
    paginationData?: GasPaginator.Data,
    tableDataPipe?: GasArgumentStream,
    url?: string,
    urlQueryParamNames?: GasUrlQueryParams,
  ): ModuleWithProviders<GasTableModule> {
    return {
      ngModule: GasTableModule,
      providers: [{
        provide: DEFAULT_REPOSITORY_PARAMS_TOKEN,
        useValue: {
          queryUrl: url,
          queryParamNames: urlQueryParamNames,
          defaultPaginatorData: paginationData,
          dataPipe: tableDataPipe,
        },
      }],
    };
  }
}
